import { render, staticRenderFns } from "./Cybermat.vue?vue&type=template&id=248c0b9f"
import script from "./Cybermat.vue?vue&type=script&lang=ts"
export * from "./Cybermat.vue?vue&type=script&lang=ts"
import style0 from "./Cybermat.vue?vue&type=style&index=0&id=248c0b9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports